<template>
    <div class="third scoreList">
        <div class="third-formOne" v-if="infoInit">
            <div class="formOne-btn">
                <div class="btn-left">
                <span class="left-back-icon" @click="changeComponent">
                    <i class="el-icon-arrow-left"></i>
                    <span class="left-back-title">返回</span>
                </span>
                <span class="left-back-shu">
                    <span class="left-back-shu-content"></span>
                </span>
                <span class="left-back-content">服务评分 》 {{ infoInit.serviceName }}</span>
                </div>
            </div>
            <div class="third-one library" style="margin-top: 57px;">
                <div class="third-do-btn">
                    <div class="do-btn-left">
                        <el-button class="do-btn-four" type="default" icon="el-icon-search" @click="filterData">数据筛选</el-button>
                        <el-button class="do-btn-four" type="default" icon="el-icon-refresh-left" @click="reset" >重置</el-button>
                    </div>
                </div>
                <el-table class="third-tableThree" :data="tableData" @selection-change="handleSelectionChange" border stripe style="width: 100%" ref="from" :row-key="getRowKey" v-loading="loading">
                    <!-- <el-table-column type="selection" :reserve-selection="true" width="32px" ></el-table-column> -->
                    <!-- <el-table-column min-width="80px" :show-overflow-tooltip="true" prop="userName" label="评分用户姓名" ></el-table-column>
                    <el-table-column min-width="80px" :show-overflow-tooltip="true" prop="userId" label="评分用户登录账号" ></el-table-column>
                    <el-table-column min-width="80px" :show-overflow-tooltip="true" prop="userType" label="评分用户身份" ></el-table-column>
                    <el-table-column min-width="80px" :show-overflow-tooltip="true" prop="score" label="评分" ></el-table-column>
                    <el-table-column min-width="80px" :show-overflow-tooltip="true" prop="createTime" label="评分时间" ></el-table-column> -->
                    <template v-for="(val,key) in tableRow">
                        <el-table-column
                            v-if="val.needKeyValue"
                            min-width="100px"
                            :prop="val.key"
                            :label="val.column"
                            :key="key"
                            :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <span style="color:red;" v-if="scope.row.status == 0">已下架</span>
                                <span style="color:#33CC99" v-if="scope.row.status == 1">已上架</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-else
                            min-width="100px"
                            :prop="val.key"
                            :label="val.column"
                            :key="key"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                    </template>

                </el-table>

                <div class="third-page">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        background
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <hign-modal
            modalTitle="数据筛选"
			:hignModalVisible="hignModal"
			@searchModal="toHignSearch"
			@cancelModal="closeModal"
			:hignOneList="tableRow"
			>
		</hign-modal>
    </div>
</template>

<script>
// import {
//   eduotheruserinfoDetailPort,
//   eduotheruserinfoSavePort,
//   eduotheruserinfoUpdatePort
// } from "@/api/c1.2/other.js";
// import myMixin from "@/mixins/pullList.js";
import { removeStore, getStore } from "@/utils/store";
import { mapActions, mapState, mapMutations } from "vuex";
import { cloneDeep } from "lodash";
import { encrypt } from "@/utils/encrypt";
export default {
//   mixins: [myMixin],
    name: "scoreList",
    data() {
        return {
            loading: false,
            hignModal: false, // 提示弹窗
            total: 0, //总共条数
            pageSize: 10, //每页条数
            currentPage: 1, //页码
            tableData: [], //列表数据
            hignSearchRes: '', // 高级检索条件
            orderConfig: '', // 顺序设置
            infoInit: '',
            tableRow: [
                {
                    column: "评分用户姓名",
                    key: "userName",
                    needKeyValue: false,
                    caseKey: "user_name"
                },
                {
                    column: "评分用户登录账号",
                    key: "userId",
                    needKeyValue: false,
                    caseKey: "account"
                },
                {
                    column: "评分用户身份",
                    key: "userType",
                    needKeyValue: false,
                    caseKey: "user_type"
                },
                {
                    column: "评分",
                    key: "score",
                    needKeyValue: false,
                    caseKey: "score"
                },
                {
                    column: "评分时间",
                    key: "createTime",
                    needKeyValue: false,
                    caseKey: "create_time"
                },
            ],
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.userInfo,
            componentsName: state => state.sensitiveWord.sensitiveWordComponentName,
        })
    },
    created() {
        this.infoInit = getStore({
            name: "rowDataTo_ScoreList",
			type: "session"
        });

    },
    mounted () {
        // this.getDealConfigFuc();
        this.getServiceScoreList();
    },
    methods: {
        ...mapActions([
            'serviceScoreList',
        ]),
        ...mapMutations({
            changeComponentName: 'SET_serviceScoreComponentName',
        }),
        filterData() {
            this.hignModal = true;
        },
        // 关闭弹窗
		closeModal() {
		    this.hignModal = false;
        },
        // 高级检索
		async toHignSearch(res) {
            this.hignSearchRes = res;
            this.hignModal = false;
            this.tableLoading = true
            this.loading = true
            const {
                data: { result, msg, status },
            } = await this.serviceScoreList([{
                current: this.currentPage, // 查询页  【必填】
                size: this.pageSize, // 每页数量  【必填】
            },
            {
                serviceId: this.infoInit.serviceId, // 服务id  【必填】
                advancedSearch: this.hignSearchRes,
                dataSortStr: this.orderConfig,
            }])
            this.loading = false
            this.tableLoading = false
            if (status === 1000) {
                console.log(result)
                this.tableData = result.records
                this.total = Number(result.total);
                return
            }
            this.$message.error(msg);
		},
        reset() {
            this.hignSearchRes = ''
            this.getServiceScoreList()
        },
        // 获取处理机制数据
        async getDealConfigFuc() {
            const {
                data: { result, msg, status }
            } = await this.getDealConfig()
            if (status === 1000) {
                console.log(result)
                this.dealConfigLists = result
                sessionStorage.setItem('SAVED_DealConfig', encrypt(this.dealConfigLists))
                return
            }
            this.$message.error(msg);
        },
        // search() {
        //     this.$refs.getAlumniWordListTable.search({
        //         pageIndex: 1,
        //     });
		// },
        //获取列表
        async getServiceScoreList() {
            this.loading = true
            const {
                data: { result, msg, status },
            } = await this.serviceScoreList([{
                current: this.currentPage, // 查询页  【必填】
                size: this.pageSize, // 每页数量  【必填】
            },
            {
                serviceId: this.infoInit.serviceId, // 服务id  【必填】
                advancedSearch: this.hignSearchRes,
                dataSortStr: this.orderConfig,
            }])
            this.loading = false
            if (status === 1000) {
                console.log(result)
                this.tableData = result.records
                this.total = Number(result.total);
                return
            }
            this.$message.error(msg);
        },
        //获取分类列表
        keywordItemList() {
            try {
                keywordItemList().then(res => {
                // console.log("我获取的敏感词分类列表", res.data);
                const data = res.data;
                if (data.status === 1000) {
                    this.SelectList = data.result;
                } else {
                    this.$message({
                        type: "error",
                        message: data.msg
                    });
                }
                });
            } catch (err) {
                console.log(err);
            }
        },
        // 改变index页面的component的值
        changeComponent() {
            removeStore({
                name: "ScoreList",
                type: "session"
            })
            this.changeComponentName("BasicPage");
        },
        //确定删除
        async deleteFN_FN() {
            let params = ''
            if (this.deleteWay == "singel") {
                params = {
                    id: this.deletRow.id
                };
            } else {
                params = {
                    id: this.multipleSelection.join()
                }
            }
            console.log(params)
            const {
                data: { msg, status }
            } = await this.removeShieldWord(params)
            if (status === 1000) {
                this.noticeModal_duoshan = false;
                this.$message.success('操作成功！');
                this.getServiceScoreList()
                return
            }
            this.$message.error(msg);
        },
        //多选删除
        duoxuandel() {
            if (this.multipleSelection.join() == "") {
                this.$message.error("请选择需要删除的数据");
                return;
            }
            this.noticeModal_duoshan = true;
            this.deleteWay = 'mul'
        },
        //删除
        deleteFN(data) {
            this.noticeModal_duoshan = true;
            this.deletRow = data;
            this.deleteWay = 'singel'
        },
        // 新增 / 详情
        toAdd(row) {
            this.$emit("goAddPage", row);
            this.changeComponentName("addNewShiledWord");
        },
        //多选------选中
        handleSelectionChange(val) {
            // console.log(val)
            let list = [];
            for (let i = 0; i < val.length; i++) {
                list.push(val[i].id);
            }
            this.multipleSelection = list;
            console.log(this.multipleSelection.join());
        },
        //保存选中状态
        getRowKey(row) {
            return row.id;
        },
        //每页显示条数---可选
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getServiceScoreList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getServiceScoreList();
        }
    }
};
</script>

<style lang="scss">
.scoreList {
    min-height: 100vh;
    .third-formOne {
        height: 100vh;
    }
    .el-table__body-wrapper {
        height: calc(100vh - 210px) !important;
    }
}
</style>
